export default __webpack_public_path__ + "static/media/ArrowDownRed.7dfdfc04.svg";